import * as React from "react";

import { Button } from "semantic-ui-react";

import { ActionableTaskButtonProps } from "./ActionableTaskButtons";

import { Link } from "redux-little-router";

const ManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton: React.FunctionComponent<ActionableTaskButtonProps> = (props: ActionableTaskButtonProps) => {
    let buttonLabel: string = null;
    if (props.task.completed) {
        buttonLabel = "View";
    } else {
        buttonLabel = "Process";
    }

    return (
        <Link href={`/actions/${props.task.caseId}/process-update-work-adjustment-questionnaire/${props.task.id}`}>
            <Button
                negative
                content={buttonLabel}
            />
        </Link>
    );
};

export { ManagerToProcessUpdateWorkAdjustmentQuestionnaireTaskButton };
